/**
 * Base file for wrapped LoadMore components.
 * Allows simple importing, e.g: import { LoadMore } from '../LoadMore';
 */

export { default as LoadMore } from './component';



// WEBPACK FOOTER //
// ./app/src/components/LoadMore/index.jsx